import React, { Fragment } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox, Spinner } from "components"
import { changeDeliveryService } from "@redux"
import { thousandSeparator } from "utils"
import classes from "./CheckboxDeliveryServiceSnapbox.module.scss"

const CheckboxDeliveryServiceSnapbox = (props) => {
  const {
    snapboxDeliveryFee,
    snapboxQuotaionLoading,
    isSnapboxOutOfService,
    snapboxDeliveryCategories,
    selectedSnapboxDeliveryCategory,
    setSelectedSnapboxDeliveryCategory
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const deliveryService =
    useSelector(state => state.deliveryInfo.deliveryService)

  const handleChangeDeliveryServiceToSnapbox = () => {
    dispatch(
      changeDeliveryService("snapbox")
    )
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        onClick={handleChangeDeliveryServiceToSnapbox}
        className={classes["option"]}
      >
        <div className={classes["row"]}>
          <Checkbox
            checked={deliveryService === "snapbox"}
            onChange={handleChangeDeliveryServiceToSnapbox}
            className={clsx(
              classes["checkbox"],
              isLtr && classes["checkbox-ltr"]
            )}
          />
          <span className={classes["checkbox-text"]}>
            {t("اسنب_باکس")}
          </span>
        </div>
        {!snapboxQuotaionLoading
          ?
          isSnapboxOutOfService
            ?
            <div className={classes["error"]}>
              {t("ارسال_موجود_نیست")}
            </div>
            :
            <div className={classes["price"]}>
              {thousandSeparator(snapboxDeliveryFee?.fee)}
            </div>
          :
          <Spinner
            color="var(--color-primary)"
            size={16}
          />
        }
      </div>
      {
        deliveryService === "snapbox" &&
        <div className={classes["delivery-categories"]}>
          {snapboxDeliveryCategories.map(snapboxDeliveryCategory =>
            <div
              key={snapboxDeliveryCategory.key}
              className={clsx(
                classes["image-container"],
                isLtr && classes["image-container-ltr"]
              )}
            >
              <img
                onClick={() => setSelectedSnapboxDeliveryCategory(snapboxDeliveryCategory)}
                src={snapboxDeliveryCategory.image}
                className={clsx(
                  classes["image"],
                  selectedSnapboxDeliveryCategory.key === snapboxDeliveryCategory.key && classes["active"]
                )}
                alt=""
              />
              <span className={classes["label"]}>
                {snapboxDeliveryCategory.name}
              </span>
            </div>
          )}
        </div>
      }
    </Fragment>
  )
}

export default React.memo(CheckboxDeliveryServiceSnapbox)